import { HouseholdYearCrudController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Shows a list of household yearly deductions.
 * @example
 * ```html
 * <salaxy-household-year-list></salaxy-household-year-list>
 * ```
 */
export class HouseholdYearList extends ComponentBase {
    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = { };

    /** Uses the HouseholdYearCrudController */
    public controller = HouseholdYearCrudController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/personal/HouseholdYearList.html";

}
